package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.*
import com.exura.components.Icon
import com.exura.components.buttons.AsyncButton
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.model.SeriesTypeInfo
import com.exura.ui.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

@Composable
internal fun SeriesEditorHeader(
    hasChanges: Boolean,
    isValid: Boolean,
    typeInfo: SeriesTypeInfo,
    isNewSeries: Boolean = false,
    viewMode: PlanCreatorInputMode = PlanCreatorInputMode.VIEW,
    onAction: () -> Unit = {},
) {
    val isInteractive = viewMode == PlanCreatorInputMode.EDIT

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(16.px),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(16.px),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(8.px),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                typeInfo.icon()
                Icon(
                    iconSrc = Assets.IconsUntiled.PROCEED,
                    size = 18.px,
                )
                typeInfo.spawnedIcon()
            }

            SpanText(
                text = typeInfo.name,
                modifier = Modifier
                    .classNames(TextStyles.medium16)
                    .color(ExuraColors.ARSENIC)
            )
        }
        Row(
            horizontalArrangement = Arrangement.spacedBy(12.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            ValidationStatusIndicator(
                isValid = isValid,
                isNewSeries = isNewSeries
            )

            AsyncButton(
                text = if (isNewSeries) "Dodaj serię" else "Zapisz serię",
                onClick = onAction,
                isDisabled = !(isValid && hasChanges && isInteractive),
            )
        }
    }
}

@Composable
private fun ValidationStatusIndicator(
    isValid: Boolean,
    isNewSeries: Boolean,
    modifier: Modifier = Modifier
) {
    val color = if (isValid) ExuraColors.GREEN else ExuraColors.ORANGE
    val text = if (isValid) {
        if (isNewSeries) "Gotowe do dodania" else "Gotowe do zapisu"
    } else {
        "Uzupełnij wymagane pola"
    }

    Row(
        horizontalArrangement = Arrangement.spacedBy(4.px),
        verticalAlignment = Alignment.CenterVertically,
        modifier = modifier
    ) {
        Box(
            modifier = Modifier
                .size(8.px)
                .borderRadius(4.px)
                .backgroundColor(color)
        )

        SpanText(
            text = text,
            modifier = Modifier
                .classNames(TextStyles.normal12)
                .color(color)
        )
    }
}
